import { render, staticRenderFns } from "./imagenes-garantia.vue?vue&type=template&id=1dbe150d"
import script from "./imagenes-garantia.vue?vue&type=script&lang=js"
export * from "./imagenes-garantia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports